RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const channelWall = Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetFacebookInsightsAuthTemplate',
        upsellTemplate: '#widgetFacebookInsightsUpsellTemplate',
        channel: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
    });

    const page = RivalIQ.configuration.menus.getConfiguration().FACEBOOK_INSIGHTS;

    curations._BaseFacebookInsightsCuration = curations._BaseInsightsCuration.extend({
        beforeFilters: [
            curations.filters.fbPresenceLoader,
            channelWall,
            curations.filters.noFacebookInsightsPresences,
            curations.filters.checkAccountAccess(RivalIQ.enums.sources.FACEBOOK_INSIGHTS),
            curations.filters.insightsLoading(RivalIQ.enums.sources.FACEBOOK_INSIGHTS, '/insights/facebook'),
            RivalIQ.apps.Dashboard.curations.filters.updateShell
        ],

        source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS,

        appTitle: 'Facebook Insights',

        title: page.name,
        exportTitle: 'Facebook Insights',

        getBasePath: function (props) {
            const me = this;
            const defaults = {
                companyId: me.getProp('companyId')
            };
            return me.router.resolveCurationRoute(me.id, _.extend(defaults, props));
        },

        canLoadAds: function () {
            const me = this;

            const hasBoostedPosts = RivalIQ.props.channelSupported(me.getProps(), RivalIQ.enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS);
            return hasBoostedPosts && me.sources[RivalIQ.enums.sources.FACEBOOK_BOOSTED_POST_INSIGHTS].validToken;
        },

        getSwitchableItems: function () {
            const me = this;

            if (me.presences) {

                const companies = me.presences.map(function (presence) {
                    return RivalIQ.state.landscape.getCompanyById(presence.get('companyId'));
                });

                return _(companies)
                    .sortBy(function (company) {
                        return company.get('name');
                    })
                    .map(function (company) {
                        const tableWidget = me.getWidget('posts-table');
                        const instanceId = me.getProp('instanceId');

                        return {
                            value: company.get('id'),
                            display: company.get('name'),
                            action: function () {
                                const companyId = company.get('id');

                                let tableLayout;
                                if (tableWidget) {
                                    tableLayout = (instanceId && (instanceId === tableWidget.getProp('instanceId'))) ? tableWidget.getProp('layout') : null;
                                }

                                const path = me.getPath({
                                    companyId: companyId,
                                    presenceId: undefined,
                                    searchTerm: '',
                                    // only tack this on if we're switching in the details view of the table widget
                                    tableLayout: tableLayout
                                });

                                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangedInsightsCompany, {
                                    company_id: companyId,
                                    channel: RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.FACEBOOK_INSIGHTS].channel
                                });

                                me.saveLastSelectedInsightsPresence(companyId);
                                RivalIQ.execute('history:navigate', path, {
                                    trigger: true
                                });
                            }
                        };
                    })
                    .value();
            }
        }
    });
});
